module.exports = __webpack_public_path__ + "img/stop.e6d4adb.png";